var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.profile.id !== 0)?_c('div',[_c('ProfileDesktop',{attrs:{"data":_vm.profile}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }